module.exports = "build/assets/stars.6ed4e973.png";